'use client'

import * as React from 'react'
import { useSnackbar } from 'notistack'
import { clientApiService } from '@/services/client-api-service'
import Snackbar from '../../Snackbar'

export default function Newsletter(): React.ReactElement {
  const [email, setEmail] = React.useState<string>('')
  const [isSubscribing, setIsSubscribing] = React.useState<boolean>(false)

  const { enqueueSnackbar } = useSnackbar()

  const handleSubscribe = React.useCallback(() => {
    void (async () => {
      setIsSubscribing(true)

      const { body, status } = await clientApiService.emailListSignup.mutate({
        body: {
          email,
        },
      })

      setIsSubscribing(false)

      if (status !== 200) {
        console.error(body)

        enqueueSnackbar(
          <Snackbar>
            <p>Invalid email address</p>
          </Snackbar>,
          { variant: 'error' },
        )

        return
      }

      enqueueSnackbar(
        <Snackbar>
          <p>Thank you for subscribing to our newsletter!</p>
        </Snackbar>,
        { variant: 'success' },
      )
      setEmail('')
    })()
  }, [email, enqueueSnackbar])

  return (
    <div className="text-primary-text dark:text-primary-text-dark w-full">
      <p className="mb-4 font-medium uppercase">Stay informed with our newsletter</p>
      <p className="text-secondary-text dark:text-secondary-text-dark mb-4 text-sm">
        Stay informed! Sign up to be the first to hear about new features, exclusive promotions, and special discounts!
      </p>
      <form
        onSubmit={(event: React.FormEvent) => {
          event.preventDefault()

          handleSubscribe()
        }}
      >
        <div className="relative mb-12 text-base">
          <div className="relative mb-6">
            <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3.5">
              <svg
                className="text-disabled-text dark:text-secondary-text-dark size-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 16"
              >
                <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
              </svg>
            </div>
            <input
              type="email"
              enterKeyHint="go"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value)
              }}
              className="input w-full pe-24 ps-10"
              placeholder="Enter your email..."
              required
            />
          </div>
          {isSubscribing ? (
            <button type="button" disabled className="button-small button-primary absolute right-2 top-[21px] -translate-y-1/2">
              <svg
                aria-hidden="true"
                role="status"
                className="spinner-on-primary -top-0.5 me-2 size-3"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
              Subscribing...
            </button>
          ) : (
            <button type="submit" className="button-small button-primary absolute right-2 top-[21px] -translate-y-1/2">
              Subscribe
            </button>
          )}
        </div>
      </form>
    </div>
  )
}
